import React, { useState, useEffect, useRef } from "react";
import { Steps, Spin, Tooltip } from "antd";
import PropTypes from "prop-types";
import { getRequest } from "../../axios";
import { InfoCircleOutlined } from "@ant-design/icons";

const SiteApprovalDotStatus = ({ prNumber, CompanyID, prID, setDotLoaded }) => {
  const [status, setStatus] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(true);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const getPurchaseRequisitionList = async () => {
      setLoading(true);
      try {
        const fields = [
        'approval_by_site','id','city_name','site_name','pr_approval_by','pr_approval_phone','pr_approval_email','pr_status','pr_approval_date', 'pr_reject_reason'
      ].join(",");
      const queryParams = new URLSearchParams({ fields });
      const apiResponse = await getRequest(
        `purchase-requisition/${prID}/get-pr-approval-data-by-site/?${queryParams.toString()}`
      );
        if (apiResponse?.data?.success) {
          let approvalData = apiResponse.data.data[0]?.approval_by_site || [];

          approvalData.sort((a, b) =>
            a.pr_status.toLowerCase() === "pending" ? -1 : 1
          );

          const formattedSteps = approvalData.map((item) => {
            const isPending = item.pr_status.toLowerCase() === "pending";

            return {
              title: (
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "#094e8f",
                  }}
                >
                  {item.city_name} - {item.site_name}
                </span>
              ),
              description: (
                <div
                  style={{
                    lineHeight: "1.0",
                    padding: "8px",
                    borderRadius: "5px",
                    backgroundColor: !isPending
                      ? "rgb(239 248 255 / 35%)"
                      : "rgb(239 248 255 / 35%)",
                    border: !isPending ? "1px solid rgb(239 239 239)" : "1px solid rgb(239 239 239)",
                  }}
                >
                  <p>
                    <strong>Status:</strong>{" "}
                    <span style={{ color: "#094e8f", fontWeight: "bold" }}>
                      {item.pr_status}
                    </span>
                  </p>
                  <p>
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {/* <strong>Approver:</strong>{" "} */}
                      {item.pr_status === "Reject With Reason" ? (
                        <strong>Rejected By:</strong>
                      ) : (
                        <strong>Approver:</strong>
                      )}
                      <span style={{ marginLeft: "5px" }}>
                        {item.pr_approval_by || "N/A"}
                      </span>
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={
                          <div
                            style={{
                              color: "white",
                              textAlign: "left",
                              padding: "8px 5px",
                            }}
                          >
                            <p style={{ margin: 0, color: "white" }}>
                              <strong>Email:</strong> {item.pr_approval_email}
                            </p>
                            <p style={{ margin: 0, color: "white" }}>
                              <strong>Mobile:</strong>{" "}
                              {item.pr_approval_phone
                                ? item.pr_approval_phone.startsWith("91")
                                  ? ` +91 ${item.pr_approval_phone.slice(2)}`
                                  : ` ${item.pr_approval_phone}`
                                : " N/A"}
                            </p>
                          </div>
                        }
                      >
                        <InfoCircleOutlined
                          style={{
                            color: "#094E8F",
                            marginLeft: "3px",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </span>
                  </p>
                  <p>
                    {item.pr_status === "Reject With Reason" ? (
                      <>
                        <p>
                          <strong>Rejected Date:</strong>{" "}
                          {item.pr_approval_date || "N/A"}
                        </p>
                        <p>
                          <strong>Reason:</strong>{" "}
                          {item.pr_reject_reason || "N/A"}
                        </p>
                      </>
                    ) : (
                      <p>
                        <strong>Approval Date:</strong>{" "}
                        {item.pr_approval_date || "N/A"}
                      </p>
                    )}
                  </p>
                </div>
              ),
              status: isPending ? "error" : "finish",
            };
          });

          setStatus(formattedSteps);
          setDotLoaded(true);
          setCurrentStep(formattedSteps.length - 1);
        }
      } catch (error) {
        console.error("Error fetching PR status:", error);
      }
      setLoading(false);
    };

    getPurchaseRequisitionList();
  }, [prID]);

  return (
    <div
      ref={scrollContainerRef}
      className="gridtimelinepopup"
      style={{
        maxHeight: "400px",
        overflowY: "auto",
        padding: "15px",
        borderRadius: "8px",
        background: "#fff",
      }}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <Spin size="medium" />
        </div>
      ) : (
        <Steps
          progressDot
          current={currentStep}
          direction="vertical"
          items={status}
        />
      )}
    </div>
  );
};

SiteApprovalDotStatus.propTypes = {
  prNumber: PropTypes.string,
  CompanyID: PropTypes.number,
  prID: PropTypes.number,
  setDotLoaded: PropTypes.func,
};

export default React.memo(SiteApprovalDotStatus);
